const getters = {
  isOld: (state) => state.user.isOld,
}
export default getters
